module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_4.48c98eaf.mp3";